'use strict';

var React = require('react');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var index_es = require('./index.es-8c72aff8.js');
var WidgetController_widgets_AppCards_type = require('./WidgetController/widgets/AppCards/type.js');
var styled = require('styled-components');
var Image = require('@swiggy-private/dls-web-core/dist/components/Image');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const getContext = (ap, cd) => {
    if (!index_es.N(ap)) {
        return JSON.stringify(ap);
    }
    if (!index_es.N(cd)) {
        return JSON.stringify(cd.map((c) => c.name));
    }
    return "";
};
const formatAppName = (appName, isLarge) => {
    if (appName.length < 9 || isLarge) {
        return appName;
    }
    return `${appName.slice(0, 5)}...`;
};
const partition = (array, isPresent) => {
    return array.reduce(([pres, rest], curr) => {
        return isPresent(curr) ? [[...pres, curr], rest] : [pres, [...rest, curr]];
    }, [[], []]);
};

const MainContainer = styled__default['default'].div(({ theme, isLarge }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: isLarge ? `0 ${theme.spacing.medium} 0 0` : "0",
}));
const Icon = styled__default['default'](Image.Image)(({ theme, isLarge }) => ({
    minWidth: isLarge ? `calc(4*${theme.spacing.medium})` : `calc(3*${theme.spacing.small})`,
    height: isLarge ? `calc(4*${theme.spacing.medium})` : "auto",
    margin: `0 0 ${theme.spacing.xSmall} 0`,
}));

const AppCard = ({ app, size = WidgetController_widgets_AppCards_type.CardSize.SMALL }) => {
    const isLarge = size === WidgetController_widgets_AppCards_type.CardSize.LARGE;
    const labelVariant = isLarge ? "tagText" : "captionText";
    const cloudinaryOptions = {
        width: isLarge ? 64 * 2 : 48 * 2,
        height: isLarge ? 64 * 2 : 48 * 2,
    };
    const handleOnClick = React.useCallback(() => {
        if (app.clickHandler)
            app.clickHandler();
    }, [app]);
    return (React__default['default'].createElement(MainContainer, { isLarge: isLarge, onClick: handleOnClick, "data-testid": app.name },
        React__default['default'].createElement(Icon, { src: index_es.D(app.icon, cloudinaryOptions), isLarge: isLarge, fit: "cover" }),
        React__default['default'].createElement(Text.Text, { variant: labelVariant, color: "text_High_Emphasis" }, formatAppName(app.displayName, isLarge))));
};
var AppCard$1 = React__default['default'].memo(AppCard);

exports.AppCard = AppCard$1;
exports.getContext = getContext;
exports.partition = partition;
//# sourceMappingURL=AppCard-1dcce203.js.map
